import { ExtensionMessage } from './models/extensionMessage.js';
import { ExtensionMessageType } from "./models/extensionMessageType.js";
import { PaymentExtensionResult } from './models/paymentExtensionResult.js';
import { RestClient } from './restClient.js';
export class PaymentExtensions {
  constructor(shop, basketId, imagineEnvironmentBaseUrl) {
    let authToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    let getNewAuthTokenFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    let customRequestHeaders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
    this.shop = shop;
    this.basketId = basketId;
    this.messageChannels = [];
    this.shop = shop;
    this.basketId = basketId;
    this.client = new RestClient(imagineEnvironmentBaseUrl, shop, authToken, getNewAuthTokenFunction, customRequestHeaders);
  }
  async initiatePayment(iframe) {
    try {
      if (!iframe) {
        throw new Error('No valid iframe provided!');
      }
      const paymentExtension = await this.getPaymentExtension();
      const messageChannel = new MessageChannel();
      const extensionRunningPromise = new Promise(resolve => {
        this.messageChannels.push(messageChannel);
        messageChannel.port1.onmessage = event => {
          this.onMessageReceived(event.data, paymentExtension, resolve);
        };
      });
      iframe.addEventListener('load', function initiateHandshake() {
        var _a;
        const handshakeMessage = new ExtensionMessage(ExtensionMessageType.Handshake, paymentExtension.encryptedPaymentExtension);
        const targetOrigin = new URL(paymentExtension.url).origin;
        (_a = this.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(handshakeMessage, targetOrigin, [messageChannel.port2]);
      }, {
        once: true
      });
      iframe.src = paymentExtension === null || paymentExtension === void 0 ? void 0 : paymentExtension.url;
      iframe.title = paymentExtension === null || paymentExtension === void 0 ? void 0 : paymentExtension.name;
      return extensionRunningPromise;
    } catch (e) {
      const errorMsg = 'Failed to initiate payment extension';
      console.error(errorMsg, e);
      return new Promise(resolve => resolve(new PaymentExtensionResult(false, errorMsg, '')));
    }
  }
  getPaymentExtension() {
    return this.client.get(`PaymentExtension/paymentExtension/${this.basketId}`);
  }
  disposeMessageListeners() {
    if (this.messageChannels && this.messageChannels.length > 0) {
      this.messageChannels.forEach(messageChannel => {
        messageChannel.port1.close();
        messageChannel.port2.close();
      });
    }
  }
  onMessageReceived(message, paymentExtension, resolve) {
    try {
      switch (message.type) {
        case ExtensionMessageType.PaymentResponse:
          this.processResponse(paymentExtension, message.encryptedPayload, resolve);
          break;
        default:
          throw new Error(`Unsupported message type ${message.type} received!`);
      }
    } catch (e) {
      console.error(e.message, e);
      this.disposeMessageListeners();
    }
  }
  async processResponse(paymentExtension, encryptedPayload, resolve) {
    {
      const paymentExtensionResponse = {
        basketId: this.basketId,
        paymentExtensionId: paymentExtension.id,
        moduleAuthId: paymentExtension.moduleAuthId,
        shop: this.shop,
        encryptedResult: encryptedPayload
      };
      var success = await this.postPaymentExtensionResponse(paymentExtensionResponse);
      this.disposeMessageListeners();
      resolve(success);
    }
  }
  async postPaymentExtensionResponse(paymentExtensionResponse) {
    try {
      return await this.client.postData('PaymentExtension/paymentExtension', paymentExtensionResponse);
    } catch (e) {
      const errorMsg = 'Failed to post payment extension response';
      console.error(errorMsg, e);
      return new Promise(resolve => resolve(new PaymentExtensionResult(false, errorMsg, '')));
    }
  }
}